import { ReactNode, useState } from 'react';
import Modal from 'react-modal';
import '../ConfirmModal/styles.scss';
import removeImg from '../../assets/images/Remove.svg';

type DialogProps = {
  children: ReactNode,
  onClick: () => Promise<void> | void;
  title: string;
  content: string;
  txtBtnCancel: string;
  txtBtnConfirm: string;
}

Modal.setAppElement('#root');

export function ConfirmModal(props: DialogProps) {
  const { children, onClick, title, content, txtBtnCancel, txtBtnConfirm } = props;

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
    overlay: {
      backgroundColor: 'rgba(0,0,0,0.7)'
    }
  };

  const [modalIsOpen, setIsOpen] = useState(false);
  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }


  async function removeQuestion() {
    setIsOpen(false);
    await onClick();
  }

  return (
    <>
      <button onClick={openModal}>{children}</button>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        aria={{ labelledby: "title", describedby: "content" }}
      >
        <div className="modal-content">
          <img src={removeImg} alt="Remover" />
          <h2 id="title">{title}</h2>
          <p id="content">{content} </p>
        </div>
        <div className="modal-footer">
          <button type="button" className="button-cancel" onClick={closeModal}>
            {txtBtnCancel}
          </button>
          <button type="button" className="button-ok" onClick={removeQuestion}>
            {txtBtnConfirm}
          </button>
        </div>
      </Modal>
    </>
  );
}